<template>
  <main class="main-wrapper-website position-relative">
    <HeaderPage />
    <AppMain />
    <MobBottomNav />
  </main>
</template>

<script>
import HeaderPage from "@/components/fixedComponents/HeaderPage.vue";
import AppMain from "./AppMain.vue";
import MobBottomNav from "@/components/fixedComponents/MobBottomNav.vue";

export default {
  name: "LayoutPage",
  components: {
    HeaderPage,
    AppMain,
    MobBottomNav,
  },
};
</script>

<style lang="scss" scoped></style>

